/* global axios */
import ApiClient from '../ApiClient';

class CaptainPromptVersions extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/prompt_versions`);
  }

  show({ assistantId, id }) {
    return axios.get(`${this.url}/${assistantId}/prompt_versions/${id}`);
  }

  restore({ assistantId, id }) {
    return axios.post(
      `${this.url}/${assistantId}/prompt_versions/${id}/restore`
    );
  }
}

export default new CaptainPromptVersions();
